import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";

const SidebarReport = (prop) => {
  const location = useLocation();
  const [dropDownState, setDropDownState] = React.useState(
    [prop.path, "/audit-report"].includes(location.pathname)
  );
  const shadeColor = React.useMemo(() => {
    const { color, percent } = prop;
    if (color && percent) {
      let R = parseInt(color.substring(1, 3), 16);
      let G = parseInt(color.substring(3, 5), 16);
      let B = parseInt(color.substring(5, 7), 16);

      R = parseInt((R * (100 + percent)) / 100);
      G = parseInt((G * (100 + percent)) / 100);
      B = parseInt((B * (100 + percent)) / 100);

      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;

      const RR =
        R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
      const GG =
        G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
      const BB =
        B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    } else {
      return "#303b93";
    }
  }, [prop.color, prop.percent]);
  const allPermissions = prop.permissions;
  return (
    <div className={`dropdown ${dropDownState ? "show" : ""}`}>
      <li>
        <Btn
          className="nav-link dd-link"
          onClick={() => setDropDownState(!dropDownState)}
        >
          <i className={prop.icon} />
          <p>Reports</p>
        </Btn>
      </li>
      <ShadedDiv shadeColor={shadeColor} className="dropdowngroup">
        {allPermissions.map((permission, key) => {
          return (
            <>
              <li key={key}>
                <NavLink
                  className={`nav-link${
                    location.pathname === permission.path ? " active" : ""
                  }`}
                  to={permission.path}
                  onClick={() => {
                    prop.handleClick(permission.path);
                  }}
                >
                  <p>
                    {permission?.name.toLowerCase().replace(/[^a-z]/g, "") ===
                    "photoverifyreport"
                      ? "Verify Audit"
                      : permission?.name.substring(
                          0,
                          permission?.name.lastIndexOf(" ")
                        )}
                  </p>
                </NavLink>
              </li>
            </>
          );
        })}
        {/* <li className="navitem">
          <NavLink
            className={`nav-link${
              location.pathname === "/report-enforcement-citation-issued"
                ? " active"
                : ""
            }`}
            to={"/report-enforcement-citation-issued"}
            onClick={() => {
              prop.handleClick("report-enforcement-citation-issued");
            }}
          >
            <p>Citation Issued</p>
          </NavLink>
        </li>
        <li className="navitem">
          <NavLink
            className={`nav-link${
              location.pathname === "/report-enforcement-citation-paid-summary"
                ? " active"
                : ""
            }`}
            to={"/report-enforcement-citation-paid-summary"}
            onClick={() => {
              prop.handleClick("report-enforcement-citation-paid-summary");
            }}
          >
            <p>Citation Paid</p>
          </NavLink>
        </li>
        <li className="navitem">
          <NavLink
            className={`nav-link${
              location.pathname === "/audit-report" ? " active" : ""
            }`}
            to={"/audit-report"}
            onClick={() => {
              prop.handleClick("audit-report");
            }}
          >
            <p>Verify Audits</p>
          </NavLink>
        </li> */}
        {/* <li className="navitem">
          <NavLink
            className={`nav-link${
              location.pathname === "/report-enforcement-citation-analysis"
                ? " active"
                : ""
            }`}
            to={"/report-enforcement-citation-analysis"}
            onClick={() => {
              prop.handleClick("report-enforcement-citation-analysis");
            }}
          >
            <p>Citation Analysis</p>
          </NavLink>
        </li>
        <li className="navitem">
          <NavLink
            className={`nav-link${
              location.pathname === "/report-citation" ? " active" : ""
            }`}
            to={"/report-citation"}
            onClick={() => {
              prop.handleClick("report-ticket");
            }}
          >
            <p>Citation</p>
          </NavLink>
        </li> */}
      </ShadedDiv>
    </div>
  );
};
const ShadedDiv = styled.ul`
  .nav-link {
    margin-left: 65px !important;
  }
  background: ${(props) => props.shadeColor} !important;
`;
const Btn = styled.a`
  cursor: pointer;
`;

export default SidebarReport;
